import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPrecios = () => {
    const element = document.querySelector('#precios');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative bg-navy-900 pt-20 md:pt-24 overflow-hidden" data-id="element-65">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0" data-id="element-66">
        <img src="https://cdn.magicpatterns.com/uploads/eADxZbxkwaySAmyFzeA8sb/heylloyd-image-1772491550164.png" alt="" className="w-full h-full object-cover" data-id="element-67" />
        <div className="absolute inset-0 bg-navy-900/80" data-id="element-68" />
      </div>

      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-69">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gold-500/10 rounded-full blur-3xl" data-id="element-70" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-burgundy-800/20 rounded-full blur-3xl" data-id="element-71" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-10" data-id="element-72">
        <div className="flex flex-col items-center text-center" data-id="element-73">
          {/* 1. Eyebrow Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="inline-flex items-center gap-2 bg-gold-500/20 border border-gold-500/30 rounded-full px-3 py-1.5 mb-4" data-id="element-74">
            <SparklesIcon className="h-3.5 w-3.5 text-gold-400" data-id="element-75" />
            <span className="text-gold-400 text-xs font-semibold tracking-wide uppercase" data-id="element-76">
              El recurso #1 para docentes de Lengua y Literatura
            </span>
          </motion.div>

          {/* 2. Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.15
        }} className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-4 md:mb-5" data-id="element-77">
            Mega Pack Lengua y Literatura:{' '}
            <span className="text-gold-400" data-id="element-78">Tu Ciclo Lectivo Resuelto.</span>
          </motion.h1>

          {/* 3. Product Image (Mockup) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative mb-4 md:mb-5" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/j36jAfcehpXErdht9YK3Le/literatura-image-1772070768884_-_Editada.png" alt="Mega Pack Lengua y Literatura - 13 tomos con material completo para docentes" className="w-64 sm:w-72 md:w-80 lg:w-96 mx-auto drop-shadow-2xl" data-id="element-80" />
            {/* Glow effect behind image */}
            <div className="absolute inset-0 bg-gradient-to-r from-gold-500/20 to-burgundy-700/20 blur-3xl scale-125 -z-10" data-id="element-81" />
          </motion.div>

          {/* 4. Subtitle / Descriptive Text */}
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.3
        }} className="text-sm sm:text-base md:text-lg text-gray-300 mb-5 md:mb-6 max-w-2xl" data-id="element-82">
            200+ recursos desarrollados para docentes que quieren recuperar sus
            fines de semana. Planificaciones, secuencias didácticas y
            evaluaciones listas para usar, alineadas al diseño curricular 2026.
          </motion.p>

          {/* 5. CTA Button */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: 0.35
        }} data-id="element-83">
            <button onClick={scrollToPrecios} className="group inline-flex items-center gap-3 bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-400 hover:to-gold-500 text-navy-900 font-bold text-base md:text-lg px-7 py-3.5 rounded-xl shadow-lg shadow-gold-500/25 hover:shadow-gold-500/40 transition-all duration-300 transform hover:scale-105" data-id="element-84">
              ¡Quiero mi pack ahora!
              <ArrowRightIcon className="h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-85" />
            </button>
          </motion.div>

          {/* Trust badges */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.4,
          delay: 0.5
        }} className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-5 md:mt-6 text-gray-400 text-xs md:text-sm" data-id="element-86">
            <div className="flex items-center gap-1.5" data-id="element-87">
              <svg className="h-4 w-4 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-88">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-89" />
              </svg>
              <span data-id="element-90">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-91">
              <svg className="h-4 w-4 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-92">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-93" />
              </svg>
              <span data-id="element-94">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-95">
              <svg className="h-4 w-4 text-green-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-96">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-97" />
              </svg>
              <span data-id="element-98">Pago seguro</span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="mt-4 md:mt-6" data-id="element-99">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-100">
          <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#f7fafc" data-id="element-101" />
        </svg>
      </div>
    </section>;
}